// extracted by mini-css-extract-plugin
export default {"rootCard":"CoachNotes_rootCard__ANx+r","noDataNotification":"CoachNotes_noDataNotification__jxl0e"};